import { persistent } from './storage.js';

/** Очереди принадлежат сотруднику, который создал действие, даже после выхода. */
export function queueOwnerId(): string | null {
  return persistent.getUser<{ id: string }>()?.id ?? null;
}

export function requireQueueOwner(): string {
  const id = queueOwnerId();
  if (!id) throw new Error('Для сохранения действия войдите в приложение.');
  return id;
}

export function belongsToCurrentUser(item: { ownerId: string }): boolean {
  return item.ownerId === queueOwnerId();
}
